import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../DatePicker';
import {Form, Modal, Message} from 'semantic-ui-react';
import moment from 'moment';

class AddSystemInfoMessageModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: true,
            message: '',
            start: null, 
            end: null
        };
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onSave = this.onSave.bind(this);
    }
    onReset(e){
        this.setState({isActive: true, message: '', start: null, end: null});
    }
    onSave(e){
        const message = {...this.state};
        const {onAdd} = this.props;
        onAdd(message);
        this.onReset();
    }
    onFieldChange(e, {name, value}){
        this.setState({[name]: value});
    }
    render() {
        const {open, onClose, error} = this.props;
        const errorContent = Array.isArray(error) ? error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : error;
        return (
            <Modal open={open} className="systemInfoMessage" onClose={onClose} closeIcon>
                <Modal.Header>Add System Information Message</Modal.Header>
                <Modal.Content>
                    <Form error>
                    <Form.Group>
                        <Form.Input placeholder="System Information Message" name="message" label="System Information Message" onChange={this.onFieldChange} value={this.state.message} />
                        <Form.Field>
								<label>Effective</label>
								<DatePicker 
                                    name='start' 
                                    selected={this.state.start ? Date.parse(moment(this.state.start).format()) : null} 
                                    onChange={this.onFieldChange}  />
							</Form.Field>
							<Form.Field>
								<label>Expires</label>
								<DatePicker 
                                    name='end' 
                                    
                                    selected={this.state.end ? Date.parse(moment(this.state.end).format()) : null} 
                                    onChange={this.onFieldChange} 
                                />
							</Form.Field>
                    </Form.Group>
                    {errorContent ? <Message
                        error
                        header="Add System Info Message Failed"
                        content={errorContent}
                        /> : null}
                    <Form.Group>
                        <Form.Button content="Reset" onClick={this.onReset} />
                        <Form.Button primary content="Save" onClick={this.onSave} />
                    </Form.Group>
                </Form>
                </Modal.Content>
            </Modal>
        );
    }
}

AddSystemInfoMessageModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default AddSystemInfoMessageModal;